import { useState, useEffect } from 'react';

const useIsMobile = threshold => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= threshold);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= threshold);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', () => handleResize);
        };
    }, []);

    return isMobile;
};

export default useIsMobile;
